import React from "react";
import DatePickerComponentV2 from "../../DatePickerComponentV2";

function GeneralInformationAdmissionSection(props) {
  const {
    translate,
    dateOfAdmission,
    handleDateOfAdmissionChange,
    dischargeDate,
    handleDischargeDateChange,
    projectedResidentialDischargeDate,
    handleProjectedResidentialDischargeDateChange,
    projectedProgramCompletionDate,
    handleProjectedProgramCompletionDateChange,
  } = props;

  return (
    <div style={{ paddingLeft: "0px", width: "100%", paddingBottom: "20px" }}>
      <div style={{ borderTop: "1px solid #cccccc", paddingTop: "20px", marginTop: "20px", gap: "10px" }}>
        <span id="admission-and-discharge" style={{ fontSize: "18px", fontWeight: "600" }}>{translate("AdmissionAndDischarge")}</span>
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <DatePickerComponentV2 title={translate("ActualAdmissionDate")} width="250px" value={dateOfAdmission} onChange={handleDateOfAdmissionChange} />
        <div style={{ paddingLeft: "10px" }}>
          <DatePickerComponentV2 title={translate("ActualDischargeDate")} width={250} value={dischargeDate} onChange={handleDischargeDateChange} />
        </div>
      </div>
      <div className="tab-form-container">
        <DatePickerComponentV2 title={translate("ProjectedDischargeDate")} width={250} value={projectedResidentialDischargeDate} onChange={handleProjectedResidentialDischargeDateChange} />
        <div style={{ display: "flex", flexDirection: "column", marginLeft: 10 }}>
          <DatePickerComponentV2 title={translate("ProjAftercareCompletionDate")} width={250} value={projectedProgramCompletionDate} onChange={handleProjectedProgramCompletionDateChange} />
        </div>
      </div>
    </div>
  );
}

export default GeneralInformationAdmissionSection;
